module.exports = __webpack_public_path__ + "img/logo_viro.9b3eb75d.png";